export const TRIALBALANCE_FETCH_SUCCESS = 'TRIALBALANCE_FETCH_SUCCESS';
export const TRIALBALANCE_FETCH_ERROR = 'TRIALBALANCE_FETCH_ERROR';
export const TRIALBALANCE_LOADER_START = 'TRIALBALANCE_LOADER_START';
export const TRIALBALANCE_LOADER_STOP = 'TRIALBALANCE_LOADER_STOP';
